import { Component, OnInit, Input, Output, EventEmitter, HostListener, HostBinding } from '@angular/core';

@Component({
  selector: 'li[app-selector-row]',
  templateUrl: './selector-row.component.html',
  styleUrls: ['./selector-row.component.scss'],
  standalone: false
})
export class SelectorRowComponent implements OnInit {

  @Input() title: string;
  @Input() key: any;
  @Input() viewType: string;
  @Input() showDrilldown: boolean;
  @Input() showCheckBox: boolean = true;
  @Input() icon: string;
  @Input() iconColor: string;
  @Input() selection: any;
  @Input() selected: boolean;
  @Input() set readonly(value: boolean) {
    this._readonly = value;
    if (this.viewType === 'groups' || this.readonly === true) {
      this.showDeleteButton = false;
    } else {
      this.showDeleteButton = true;
    }
  }
  get readonly(): boolean {
    return this._readonly;
  }
  @Input() templateReadonly: boolean = false;
  @Input() editingTemplate: boolean = false;
  @Output() selectedChange = new EventEmitter<boolean>();
  @Output() drilldown = new EventEmitter();

  _readonly: boolean = false;
  showDeleteButton: boolean;
  checkboxId: string;
  checkboxLabel: string;

  @HostBinding('class') hostClasses = 'collection-item';

  constructor() { }

  ngOnInit() {
    this.checkboxId = this.title?.replace(/\s+/g, '') + '-checkbox';
    this.checkboxLabel = this.title?.replace(/\s+/g, '') + '-label';
    if (this.viewType === 'groups') {
      this.showDeleteButton = false;
    } else {
      this.showCheckBox = false;
      if (this.readonly === true) {
        this.showDeleteButton = false;
      } else {
        this.showDeleteButton = true;
      }
    }
  }

  removeSelection() {
    this.selected = false;
    this.selectedChange.emit(this.selected);
  }

  onDrilldown(event: Event) {
    this.drilldown.emit(this.key);
    event.stopPropagation();
  }

  onSelectedChange(event: Event) {
    if (!this.readonly) {
      this.selected = !this.selected;
      this.selectedChange.emit(this.selected);
      event.stopPropagation();
    }
  }

  @HostListener('click', ['$event'])
  onDefault(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    // if you can drill in, don't select and drill in
    if (this.showDrilldown) {
      this.onDrilldown(event);
      return;
    }
    // if it is not a read only group select
    if (!this.readonly && this.showCheckBox) {
      this.onSelectedChange(event)
    }
  }
}
